
import {Component, Mixins, Prop, Watch} from "vue-property-decorator";
import ObjectInputMixin from "@/mixins/ObjectInputMixin.vue";
import FormWrapper from "@/components/FormWrapper.vue";
import {NotEntity} from "@/entity/NotEntity";
import TakipBorcluPicker from "@/components/pickers/TakipBorcluPicker.vue";
import NotSablonPicker from "@/components/pickers/NotSablonPicker.vue";
import NotEditor from "@/components/inputs/NotEditor.vue";
import {NotSablonEntity} from "@/entity/NotSablonEntity";
import NotTurPicker from "@/components/pickers/NotTurPicker.vue";
import AlacakliPicker from "@/components/pickers/AlacakliPicker.vue";

@Component({
  components: {AlacakliPicker, NotTurPicker, NotEditor, NotSablonPicker, TakipBorcluPicker, FormWrapper}
})
export default class NotForm extends Mixins(ObjectInputMixin) {
  @Prop() hideCloseButton!: any;
  @Prop() hideSubmitButton!: string | boolean;
  @Prop() takipId!: number;
  @Prop() defaultType!: number | null;
  @Prop() defaultBorclu!: number | null;
  @Prop() alacakliBorcluVisible!: boolean;

  localValue: NotEntity = new NotEntity();
  secilenSablon: any = new NotSablonEntity();
  error = false;

  notBilgileri: {
    not_tur_id: number;
    alacakli_id: number;
    borclu_id: number;
    not: string | null;
  } = {
    not_tur_id: 0,
    alacakli_id: 0,
    borclu_id: 0,
    not: null,
  };

  onSablonChange() {
    this.localValue.not = this.secilenSablon.not;
  }

  @Watch('localValue.not')
  isMailChange() {
    this.error = false;
  }

  @Watch('localValue.not')
  @Watch('localValue.not_tur_id')
  emitValues() {
    this.notBilgileri = {
      not_tur_id: this.localValue.not_tur_id,
      alacakli_id: 0,
      borclu_id: 0,
      not: this.localValue.not
    };
    this.$emit('notBilgileri', this.notBilgileri);
  }

  mounted() {
    if (this.defaultType && !this.localValue.id)
      this.localValue.not_tur_id = this.defaultType;
    if (this.defaultBorclu && !this.localValue.id)
      this.localValue.borclu_id = this.defaultBorclu;
  }

  save() {
    // Alan doğrulamaları
    if (!this.localValue.not || this.localValue.not === "" || this.localValue.not === "<p></p>") {
      this.error = true;
      this.$toast.error("Not metni giriniz.");
      return;
    }
    if (!this.localValue.not_tur_id) {
      this.$toast.error("Not türü seçiniz.");
      return;
    }
    if (this.alacakliBorcluVisible) {
      if (!this.localValue.alacakli_id) {
        this.$toast.error("Alacaklı seçiniz.");
        return;
      }
      if (!this.localValue.borclu_id) {
        this.$toast.error("Borçlu seçiniz.");
        return;
      }
    }

    const payload: any = { ...this.localValue };
    payload.takip_id = Number(payload.takip_id || this.takipId);

    if (this.localValue.id) {
      this.$http.put('/api/v1/not/' + this.localValue.id, payload).then(() => {
        this.$emit('onSuccess');
      });
    } else {
      this.$http.post('/api/v1/not/', payload).then(() => {
        this.localValue = new NotEntity();
        this.localValue.not = null;
        if (this.defaultType) this.localValue.not_tur_id = this.defaultType;
        if (this.defaultBorclu) this.localValue.borclu_id = this.defaultBorclu;
        this.$emit('onSuccess');
      });
    }
  }

  async close() {
    await this.resetValue();
    this.$emit('onClose');
  }

  async resetValue() {
    if (!this.localValue.id) {
      this.localValue = new NotEntity();
      delete this.$data.secilenSablon;
      this.input();
    }
  }
}
